<template>
  <div class="login-holder">
    <div class="login-box">
      <div class="container-fluid">
        <img src="../assets/logo.png" alt="PropertyPistol Syndicate Logo" />
        <form @submit.prevent="resetPassword">
          <div class="form-group">
            <input
              type="email"
              class="form-control p-4"
              placeholder="Email"
              required
              v-model="$v.email.$model"
              ref="email"
            />
          </div>
          <div class="error">{{validationMsg($v.email)}}</div>
          <div class="form-group">
            <button :disabled="$v.$invalid" type="submit" class="btn btn-primary mt-5 btn-block">
              Send Reset Link
            </button>
          </div>

        </form>
      </div>
    </div>
  </div>
</template>
<script>
import { required } from 'vuelidate/lib/validators';
import { validationMessage } from 'vuelidate-messages';
const formMessages = {
  required: () => 'Field is required'
}
export default {
    name:"ForgotPassword",
    data(){
    return{
      email: null
    }
  },
  methods: {
    resetPassword(){
      let email = this.email
      let forgotUrl = '/forgot_password'
      this.$axios.put(forgotUrl, {email: email})
        .then(res => {
          swal({
            title: "Reset Link Sent to Your Registered e-mail",
            text: 'Sent!',
            icon: "success"
          })
          this.$router.replace('/login');
        })
      .catch(err => {
        if (err.response.status === 500) {
          swal({
            title: "Server Error!",
            icon: "error"
          });
        } else {
          swal({
            title: "Error",
            text: err.response.data.message,
            icon: "error"
          });
        }
      })
    }
  },
  validations: {
    email: {
      required
    }
  },
  computed: {
    validationMsg(){
      return validationMessage(formMessages);
    }
  }
};
</script>
<style scoped>
.login-holder {
  height: 100vh;
  position: relative;
  background: #fff;
}
.login-box {
  position: absolute;
  width: 100%;
  top: 50%;
  transform: translate(0, -50%);
}
.login-box img {
  margin: 0 auto 100px;
  display: table;
  max-width: 190px;
}
.f14{
  font-size:14px ;
}
</style>